import { Component } from "@rhinov/savane-js";
import { ComponentController } from "../ComponentController";

interface EventMapping {
    id: string;
    event: string;
    handler: (event: Event) => void;
}

export class ComponentWidget {

    controller: ComponentController;
    component: Component;
    index: number;

    protected componentDetails(event: MouseEvent) {
        if (event.ctrlKey) {
            this.controller.openComponentDetail(this.component);
        }
    }

    protected report() {
        this.controller.openComponentAssetIssue(this.component);
    }

    protected copyId() {
        this.controller.copyComponentAssetID(this.component);
    }

    commonEvents: EventMapping[] = [
        {id:"detailsComponent-", event: "mousedown", handler: (e: Event) => this.componentDetails(e as MouseEvent)},
        {id:"reportButton-", event: "click", handler: () => this.report()},
        {id:"copyIdComponent-", event: "click", handler: () => this.copyId()},
    ];
    
    constructor(component: Component, index: number){
        this.component = component;
        this.controller = new ComponentController(component);
        this.index = index;
    }

    setCommonListener() {
        this.commonEvents.forEach(({id, event, handler}) => {
            let element = document.getElementById(id + this.index);
            if (!element) return;
            element.addEventListener(event, handler);
        })
    }

    removeCommonListener() {
        this.commonEvents.forEach(({id, event, handler}) => {
            let element = document.getElementById(id + this.index);
            if (!element) return;
            element.removeEventListener(event, handler);
        })
    }

    CommonHeader(isName: boolean): string {
        return `
        
            <div class="componentInfos" style="padding-top:12px;padding-bottom:12px">
                <div>
                    <img src="${this.controller.getPreview()}" style="width:64px;height:64px;border: 1px solid #a49e95" id="detailsComponent-${this.index}"/>
                </div>
                <a id="reportButton-${this.index} title="Reporter un problème"
                    style="margin-bottom:0px;margin-left:10px;cursor: pointer;" class="icon-SMS"></a>
                <a id="copyIdComponent-${this.index}" title="Copier ID vers presse papier"
                    style="margin-bottom:0px;margin-left:4px;cursor: pointer;" class="icon-FloatBar_Lens"></a>
                <div style="padding-left:12px;padding-right:12px;width:100%">
                    ${this.controller.getName()}
                </div>
                ${isName ? `<div style="padding-left:64px;padding-right:12px;width:100%">
                    ${this.component.name}
                </div>` : ""}
            </div>

        `
    }
    destroy() {
        this.removeCommonListener();
    }

    setListener() {
        this.setCommonListener();
    }
}